import { render, staticRenderFns } from "./AuditLogsList.vue?vue&type=template&id=3992c48b&scoped=true"
import script from "./AuditLogsList.vue?vue&type=script&lang=js"
export * from "./AuditLogsList.vue?vue&type=script&lang=js"
import style0 from "./AuditLogsList.vue?vue&type=style&index=0&id=3992c48b&prod&lang=scss"
import style1 from "./AuditLogsList.vue?vue&type=style&index=1&id=3992c48b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3992c48b",
  null
  
)

export default component.exports